<dx-box width="100%" height="100%" direction="row" class="top-menu-container">
    <dxi-item [ratio]="0.25" [visible]="showQuickSearch">
        <div *dxTemplate>
            <dx-box width="100%" height="100%" direction="row">
                <dxi-item baseSize="auto">
                    <div *dxTemplate class="cc-search-toolbar-container">
                        <div class="toolbar-item-container">
                            <div class="toolbar-button-container">
                                <div class="button-container" *ngFor="let btn of searchButtons">
                                    <dx-button
                                        type="normal"
                                        stylingMode="text"
                                        [ngClass]="{
                                            'search-button search-button-inverse': !btn.selected,
                                            'selected-search-button': btn.selected
                                        }"
                                        [icon]="btn.icon"
                                        [hint]="btn.hint"
                                        (onClick)="onSearchClick(btn)"
                                    ></dx-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </dxi-item>
                <dxi-item [ratio]="1">
                    <div *dxTemplate>
                        <app-current-owner-quick-search
                            *ngIf="selectedButton.name === 'owner'"
                            placeholder="Search Current Owners"
                            [searchText]="searchText"
                            [searchTextClass]="'inverse-color'"
                            (onTextSearched)="onTextSearched($event)"
                        ></app-current-owner-quick-search>
                        <app-community-quick-search
                            *ngIf="selectedButton.name === 'community'"
                            [searchText]="searchText"
                            [searchTextClass]="'inverse-color'"
                            (onTextSearched)="onTextSearched($event)"
                        ></app-community-quick-search>
                    </div>
                </dxi-item>
            </dx-box>
        </div>
    </dxi-item>
    <dxi-item [ratio]="showQuickSearch ? 0.75 : 1">
        <div *dxTemplate [ngClass]="{ 'menu-container': showQuickSearch }">
            <dx-menu
                #topMenu
                displayExpr="text"
                orientation="horizontal"
                itemTemplate="menu-item-template"
                cssClass="top-menu-control"
                selectionMode="none"
                selectedExpr=""
                [adaptivityEnabled]="true"
                [activeStateEnabled]="false"
                [focusStateEnabled]="false"
                [hideSubmenuOnMouseLeave]="true"
                [showFirstSubmenuMode]="{ name: 'onHover', delay: { show: 50, hide: 500 } }"
                [dataSource]="menuItems"
                (onItemClick)="onMenuItemClick($event)"
                (onSubmenuShowing)="onSubmenuShowing($event)"
                (onSubmenuHiding)="onSubmenuHiding($event)"
            >
                <div *dxTemplate="let item of 'menu-item-template'">
                    <div
                        id="{{ item.id }}"
                        class="menu-item-template"
                        [ngClass]="{ 'dx-theme-accent-as-text-color': isSelected(item) }"
                        (mouseenter)="onMouseEnter(item)"
                        (mouseleave)="onMouseLeave(item)"
                    >
                        <div class="menu-icon">
                            <i [class]="item.icon"></i>
                        </div>
                        <div class="menu-text" [ngClass]="{ 'cc-hidden-menu-text': hideMenuText(item) }">
                            <span
                                *ngIf="isInDevOrQaRelease(item)"
                                [ngClass]="{
                                    'cc-qa-release-menu': isInQaRelease(item),
                                    'cc-dev-release-menu': !isInQaRelease(item)
                                }"
                            >
                                **&nbsp;{{ item.text }}&nbsp;**
                            </span>
                            <span *ngIf="!isInDevOrQaRelease(item)">
                                {{ item.text }}
                            </span>
                            <app-security-info
                                *ngIf="item.isInternal && item.isSpecificRole"
                                securityIndicator="KEY"
                                [accessCode]="item.name"
                            ></app-security-info>
                            <app-security-info
                                *ngIf="item.isInternal && !item.isSpecificRole"
                                securityIndicator="LOCK"
                                [accessCode]="item.name"
                            ></app-security-info>
                        </div>
                        <div class="menu-arrow-icon" *ngIf="item.items.length > 0">
                            <i class="fas fa-caret-right"></i>
                        </div>
                        <div class="menu-separator" *ngIf="!isLastItem(item)">
                            <span class="dx-theme-border-color"></span>
                        </div>
                    </div>
                </div>
            </dx-menu>
        </div>
    </dxi-item>
    <dxi-item baseSize="auto" [visible]="showFooterIcons">
        <div *dxTemplate [ngClass]="{ 'menu-container': showQuickSearch }">
            <dx-menu
                #bottomMenu
                displayExpr="text"
                orientation="horizontal"
                itemTemplate="menu-item-template"
                cssClass="bottom-menu-control"
                selectionMode="none"
                selectedExpr=""
                [adaptivityEnabled]="true"
                [activeStateEnabled]="false"
                [focusStateEnabled]="false"
                [hideSubmenuOnMouseLeave]="false"
                [showFirstSubmenuMode]="{ name: 'onHover', delay: { show: 50, hide: 500 } }"
                [dataSource]="bottomMenuData"
            >
                <div *dxTemplate="let item of 'menu-item-template'">
                    <div class="cc-search-toolbar-container">
                        <div class="toolbar-item-container">
                            <div class="toolbar-button-container">
                                <div class="button-container">
                                    <dx-button
                                        type="normal"
                                        stylingMode="text"
                                        [ngClass]="{
                                            'search-button search-button-inverse': !item.selected,
                                            'selected-search-button': item.selected
                                        }"
                                        [icon]="item.icon"
                                        [hint]="item.tooltip"
                                        (onClick)="onBottomItemClick(item)"
                                    >
                                        <div *dxTemplate="let c of 'content'">
                                            <i
                                                *ngIf="c.icon.indexOf('span') === -1"
                                                class="dx-icon"
                                                aria-hidden="true"
                                                [ngClass]="c.icon"
                                            ></i>
                                            <div
                                                *ngIf="c.icon.indexOf('span') !== -1"
                                                [innerHTML]="c.icon | ccSafeHtml"
                                            ></div>
                                        </div>
                                    </dx-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </dx-menu>
        </div>
    </dxi-item>
</dx-box>
